export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_COMPLETED = "SIGN_IN_COMPLETED";
export const SIGN_IN_REQUESTED = "SIGN_IN_REQUESTED";
export const SIGN_IN_FAILED = "SIGN_IN_FAILED";

export const SIGN_OUT = "SIGN_OUT";
export const RESET_STATE = "RESET_STATE";
export const OBSERVER = "OBSERVER";